<style>
	 @import '@/assets/css/custom.css';

	/* Stock Notice Alert Animation */
	.stock-notice-alert {
		animation: slideInBounce 0.6s ease-out;
		border-left: 5px solid;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		position: relative;
		overflow: hidden;
		color: #8b0000 !important;
		font-weight: 600;
	}

	.stock-notice-alert::before {
		content: '';
		position: absolute;
		top: 0;
		left: -100%;
		width: 100%;
		height: 100%;
		background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
		animation: shimmer 2s infinite;
	}

	.stock-notice-alert strong {
		color: #6b0000 !important;
		font-weight: 700;
	}

	.stock-notice-alert.alert-warning {
		border-left-color: #ff9800;
		background-color: #fff8e1;
		color: #8b0000 !important;
	}

	.stock-notice-alert.alert-warning strong {
		color: #6b0000 !important;
		font-weight: 700;
	}

	.stock-notice-alert.alert-info {
		border-left-color: #17a2b8;
		background-color: #e7f3f5;
		color: #8b0000 !important;
	}

	.stock-notice-alert.alert-info strong {
		color: #6b0000 !important;
		font-weight: 700;
	}

	@keyframes slideInBounce {
		0% {
			transform: translateX(-100%);
			opacity: 0;
		}
		60% {
			transform: translateX(10px);
			opacity: 1;
		}
		80% {
			transform: translateX(-5px);
		}
		100% {
			transform: translateX(0);
			opacity: 1;
		}
	}

	@keyframes shimmer {
		0% {
			left: -100%;
		}
		100% {
			left: 100%;
		}
	}

	/* Icon animation */
	.stock-notice-alert i {
		display: inline-block;
		animation: bounceIcon 1.5s ease-in-out infinite;
	}

	@keyframes bounceIcon {
		0%, 100% {
			transform: translateY(0);
		}
		50% {
			transform: translateY(-5px);
		}
	}
</style>

<template>
    <div>
        <Breadcrumbs main="Service Management" title="Services" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list page-subtitle">
								<div class="row">
									<div class="col-md-12">
										<router-link :to="{ name: 'add_complaint' }" class="btn btn-primary float-end">Add Service</router-link>
									</div>
								</div>
							</div>

								<div class="col-md-12 project-list filter-sort mb-3">
									<div class="row">
										<div class="col-md-4 d-flex align-items-end gap-3 mt-2">
											<div>
												<label class="control-label d-block">Total Complaints:</label>
												<span class="badge rounded-pill bg-primary fs-6">{{ total }}</span>
											</div>
											<button type="button" class="btn btn-success" @click="downloadServicesExcel()" :disabled="!start_date || !end_date || excel_loading">
												{{ excel_loading ? 'Exporting...' : 'Export Excel' }}
											</button>
										</div>
										<div class="col-md-2 mt-2">
											<label class="control-label">Status</label>
											<select class="form-select" v-model="status" @change="fetchServices()">
												<option value="">All</option>
												<option value="1">Pending</option>
												<option value="2">Ongoing</option>
												<option value="3">Completed</option>
												<option value="4">Manufacturer</option>
												<option value="5">Assigned to Speedtech</option>
												<option value="6">Assigned to Dealer</option>
											</select>
										</div>
										<div class="col-md-3 mt-2">
											<label class="control-label">Start Date:</label>
											<input class="form-control" type="date" v-model="start_date" :max="max" value-as-string @change="fetchServices()">
										</div>
										<div class="col-md-3 mt-2">
											<label class="control-label">End Date:</label>
											<input class="form-control" type="date" v-model="end_date" :max="max" value-as-string @change="fetchServices()">
										</div>
									</div>
								</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-6 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="fetchServices()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
												<option value="50">50</option>
												<option value="100">100</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-4 mt-2"></div>
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control ms-1 float-end" placeholder="Search" v-model="keyword" @input="fetchServices()" />
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
                                            <th>IMEI</th>
											<th>Dealer</th>
											<th>Contact</th>
											<th>Service Type</th>
											<th>Details</th>
											<th>Date</th>
											<th>Added By</th>
                                            <th>Status</th>
											<th>Amount</th>
											<th>Payment Data</th>
											<th>Options</th>
                                        </tr>
									</thead>
									<tbody v-if="Boolean(services.length)">
										<tr v-for="(service, index) in services" :key="service.id" align="center">
                                            <td>{{ index + 1 }}</td>
											<td>
												<b>IMEI:-</b>{{ service.imei }} <br> 
												<b>ICCID:-</b>{{ service.iccid }} <br>
												<b>SIM Provider:-</b>{{ service.sim_provider || '-' }}
											</td>
											<td>{{ formatDealerName(service) }}</td>
											<td>
												<span v-if="service.vehicle_no">Vehicle No: {{ service.vehicle_no }}</span>
												<br>
												<span v-if="service.mobile">Contact: {{ service.mobile }}</span>
											</td>
											<td>
												<b>{{ service.service_type == 1 ? 'SIM Change' : service.service_type == 2 ? 'Repair' : service.service_type == 3 ? 'Replacement' : service.service_type == 4 ? 'No Data' : service.service_type == 5 ? 'Tracking Issue' : service.service_type == 6 ? 'Hardware Issue' : service.service_type == 7 ? 'Software Issue' : service.service_type == 8 ? 'Alert Fail' : service.service_type == 9 ? 'Other' : service.service_type == 10 ? 'Renewal Replacement' : 'N/A' }}</b><br>
												<span class="badge rounded-pill bg-info" v-if="service.work_status==1">Pending</span>
												<span class="badge rounded-pill bg-success" v-if="service.work_status==2">Completed</span>

												<span class="badge rounded-pill bg-danger" v-if="service.service_type == 10 && service.received_status == 2">Device Not Received</span>
												
												<span v-if="service.work_type !== null"> 
                                                    <span class="badge rounded-pill bg-primary" v-if="service.work_type==1">On Field</span>
                                                    <span class="badge rounded-pill bg-secondary" v-if="service.work_type==2">At Office</span>
                                                </span>
											</td>
											<td>{{ service.details }}</td>
											<td>{{ service.created_date }}</td>
											<td>{{ service.added_user_name }}</td>
											<td>
												<span class="badge rounded-pill bg-info" v-if="service.status==1">Pending</span>
												<span class="badge rounded-pill bg-warning" v-if="service.status==2">Ongoing</span>
												<span class="badge rounded-pill bg-success" v-if="service.status==3">Completed</span>
												<span class="badge rounded-pill bg-secondary" v-if="service.status==4">To Vendor</span>
												<span class="badge rounded-pill bg-primary" v-if="service.status==5">Component Replacement</span>

												<span v-if="service.remarks">
													<br><b>Remarks:</b> {{ service.remarks }}
												</span>
											</td>
											<td>
												<span v-if="service.total_amount">
													Total: ₹{{ service.total_amount }} <br>
													Online: ₹{{ service.cash_online ? service.cash_online : '0.00' }} <br>
													Cash: ₹{{ service.cash_in_hand ? service.cash_in_hand : '0.00' }} <br>
													Balance: ₹{{ service.balance_amount ? service.balance_amount : '0.00' }}
												</span>
											</td>
											<td>
												Payment Type: <span class="badge rounded-pill bg-primary" v-if="service.payment_type==1">Online</span>
												<span class="badge rounded-pill bg-secondary" v-if="service.payment_type==2">Cash</span>
												<span class="badge rounded-pill bg-success" v-if="service.payment_type==3">Both</span>
												<br>
												Payment Status: <span class="badge rounded-pill bg-success" v-if="service.payment_status==1">Received</span>
												<span class="badge rounded-pill bg-danger" v-if="service.payment_status==2">Not Received</span>
												<span class="badge rounded-pill bg-warning" v-if="service.payment_status==3">Partially Received</span>
											</td>
                                            <td>
												<button v-if="service.status === 1" class="btn btn-light btn-sm mt-1 me-2" @click="assignToSpeedtech(service.id)" :disabled="service.service_type == 10 && service.received_status == 2">Assign to Speedtech</button>
												<button
													v-if="service.service_type == 10 && service.received_status == 2"
													class="btn btn-dark btn-sm mt-1 me-2"
													@click="markAsReceived(service.id)"
												>
													Mark as Received
												</button>
												<router-link :to="{ name: 'complaint_details', params: { id: service.id } }" class="btn btn-primary btn-sm me-2 mt-1">Details</router-link>
											
												<button class="btn btn-warning btn-sm mt-1 me-1" @click="openComponentUpdateModal(service.id)" :disabled="service.service_type == 10 && service.received_status == 2">Component Update</button>
												<button v-if="service.status !== 4" class="btn btn-info btn-sm mt-1 me-1" @click="openToManufacturerModal(service.id)" :disabled="service.service_type == 10 && service.received_status == 2">To Manufacturer</button>
												<button class="btn btn-secondary btn-sm mt-1 me-1" @click="openSimChangeModal(service.id)" :disabled="service.service_type == 10 && service.received_status == 2">SIM Change</button>
												<button class="btn btn-success btn-sm mt-1 me-1" @click="openCompletedModal(service.id)" :disabled="service.work_status === 1 || (service.service_type == 10 && service.received_status == 2)">Completed</button>
												<button v-if="service.status === 1" class="btn btn-danger btn-sm mt-1 me-1" @click="deleteService(service.id)">Delete</button>
												<!-- <button class="btn btn-warning btn-sm mt-1" @click="openUpdateServiceModal(service)" v-if="$canUpdateRenewalData()">Update Service Data</button> -->
                                            </td>
                                        </tr>
                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="12" align="center">No data available in the table</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<caption v-if="Boolean(services.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
							<nav aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchServices(page.url + '&limit=' + listing_length + '&status=' + status + '&keyword=' + keyword + '&from_date=' + start_date + '&to_date=' + end_date)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav> 
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title=modal_title>
			<template #body>
				<form @submit.prevent="" enctype="multipart/form-data">
					<div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Status<span class="text-danger">*</span></label>
                        	<select class="form-select" v-model="complaint_status">
								<option value="">--Select--</option>
								<option value="1">Completed</option>
							</select>
                        </div>
                    </div>

					<div class="col-md-12 form-group mt-2">
						<label class="control-label">Material Change<span class="text-danger">*</span></label>
						<select class="form-select" v-model="material_change">
							<option value="">--Select--</option>
							<option value="1">Yes</option>
							<option value="2">No</option>
						</select>
					</div>

					<div class="row">
						<div class="col-md-6 form-group mt-2" v-if="material_change == 1">
							<label class="control-label">Material<span class="text-danger">*</span></label>
							<select class="form-select" v-model="product_id">
								<option value="">--Select--</option>
								<option value="1">Material 1</option>
								<option value="2">Material 2</option>
								<option value="3">Material 3</option>
								<option value="4">Material 4</option>
							</select>
						</div>

						<div class="col-md-6 form-group mt-2" v-if="material_change == 1">
							<label class="control-label">Quantity<span class="text-danger">*</span></label>
							<input class="form-control" type="text" placeholder="" v-model="quantity"/>
						</div>
					</div>

					<div class="col-md-12 form-group mt-2" v-if="complaint_status == 1">
						<label class="control-label">Total Amount<span class="text-danger">*</span></label>
						<input class="form-control" type="number" step="0.01" min="0" placeholder="Enter total amount" v-model="cost"/>
					</div>

					<!-- Payment Status Section -->
					<div class="col-md-12 form-group mt-2" v-if="complaint_status == 1">
						<label class="control-label">Payment Status<span class="text-danger">*</span></label>
						<select class="form-select" v-model="payment_status">
							<option value="">--Select Payment Status--</option>
							<option value="received">Received</option>
							<option value="not_received">Not Received</option>
						</select>
					</div>

					<!-- Payment Type Section - Only show if payment is received -->
					<div class="col-md-12 form-group mt-2" v-if="complaint_status == 1 && payment_status == 'received'">
						<label class="control-label">Payment Type<span class="text-danger">*</span></label>
						<select class="form-select" v-model="payment_type" @change="onPaymentTypeChange">
							<option value="">--Select Payment Type--</option>
							<option value="1">Online</option>
							<option value="2">Cash</option>
							<option value="3">Both</option>
						</select>
					</div>

					<!-- Online Payment Details -->
					<div class="row" v-if="complaint_status == 1 && payment_status == 'received' && (payment_type == '1' || payment_type == '3')">
						<div class="col-md-6 form-group mt-2">
							<label class="control-label">Online Amount<span class="text-danger">*</span></label>
							<input class="form-control" type="number" step="0.01" min="0" placeholder="Enter online amount" v-model="online_amount"/>
						</div>
						<div class="col-md-6 form-group mt-2">
							<label class="control-label">Payment ID<span class="text-danger">*</span></label>
							<input class="form-control" type="text" placeholder="Enter payment ID" v-model="payment_id"/>
						</div>
					</div>

					<!-- Cash Payment Details -->
					<div class="col-md-12 form-group mt-2" v-if="complaint_status == 1 && payment_status == 'received' && (payment_type == '2' || payment_type == '3')">
						<label class="control-label">Cash Amount<span class="text-danger">*</span></label>
						<input class="form-control" type="number" step="0.01" min="0" placeholder="Enter cash amount" v-model="cash_amount"/>
					</div>

					<!-- Payment Breakdown Display -->
					<div class="col-md-12 mt-2" v-if="complaint_status == 1 && payment_status == 'received' && payment_type && getPaymentBreakdown()">
						<div class="card border-light">
							<div class="card-body p-2">
								<div class="row text-center">
									<div class="col-md-3">
										<small class="text-muted">Total Amount</small>
										<div class="fw-bold">₹{{ getPaymentBreakdown().total }}</div>
									</div>
									<div class="col-md-3" v-if="payment_type === '1' || payment_type === '3'">
										<small class="text-muted">Online</small>
										<div class="fw-bold">₹{{ getPaymentBreakdown().online }}</div>
									</div>
									<div class="col-md-3" v-if="payment_type === '2' || payment_type === '3'">
										<small class="text-muted">Cash</small>
										<div class="fw-bold">₹{{ getPaymentBreakdown().cash }}</div>
									</div>
									<div class="col-md-3">
										<small class="text-muted">Status</small>
										<div class="fw-bold" :class="getPaymentBreakdown().statusClass">
											{{ getPaymentBreakdown().statusLabel }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				
					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" @click="submitStatusUpdate">{{ button_title }}</button>
						<button class="btn btn-light" type="button" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

		<!-- Component Update Modal -->
		<div class="modal fade" id="componentUpdateModal" tabindex="-1" aria-labelledby="componentUpdateModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="componentUpdateModalLabel">Component Update</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<form @submit.prevent="submitComponentUpdate" enctype="multipart/form-data">
							<!-- Stock Deduction Notice -->
							<div class="col-md-12 mb-3" v-if="currentServiceStatus">
								<div class="alert stock-notice-alert" :class="currentServiceStatus === 4 ? 'alert-warning' : 'alert-info'">
									<i class="icofont icofont-info-circle me-2"></i>
									<strong>Note:</strong> 
									<span v-if="currentServiceStatus === 4">
										Raw material stock will be deducted from <strong>{{ currentVendorName || 'Vendor' }}</strong>.
									</span>
									<span v-else>
										Raw material stock will be deducted from <strong>AIROTRACK</strong> raw materials.
									</span>
								</div>
							</div>
							<div class="col-md-12 mt-2">
								<div v-for="(material, index) in componentMaterials" :key="index" class="mb-3 p-3 border rounded">
									<div class="row g-2">
										<div class="col-md-7 col-12 form-group">
											<label class="control-label">Material<span class="text-danger">*</span></label>
											<div class="position-relative">
												<input 
													v-model="material.search" 
													class="form-control" 
													placeholder="Search material by name or description..."
													@input="searchMaterial(index)"
													@focus="material.showSuggestions = true"
													@blur="hideMaterialSuggestions(index)"
													required
												/>
												<div v-if="material.showSuggestions && material.filteredList.length > 0" class="position-absolute w-100 bg-white border rounded shadow-sm" style="z-index: 1000; max-height: 200px; overflow-y: auto; margin-top: 2px;">
													<div 
														v-for="mat in material.filteredList" 
														:key="mat.id"
														class="p-2 border-bottom cursor-pointer hover-bg-light"
														@click="selectMaterial(index, mat)"
														style="cursor: pointer;"
													>
														<div class="fw-bold">{{ mat.raw_material_name }}</div>
														<small class="text-muted">{{ mat.description }}</small>
													</div>
												</div>
											</div>
											<div v-if="material.selectedMaterial" class="mt-2">
												<small class="text-success">
													<i class="icofont icofont-check-circled me-1"></i>
													Selected: <strong>{{ material.selectedMaterial.raw_material_name }}</strong>
												</small>
											</div>
										</div>
										<div class="col-md-3 col-8 form-group">
											<label class="control-label">Quantity<span class="text-danger">*</span></label>
											<input 
												class="form-control" 
												type="number" 
												min="1" 
												placeholder="Qty" 
												v-model.number="material.qty"
												required
											/>
										</div>
										<div class="col-md-2 col-4 form-group d-flex align-items-end" v-if="componentMaterials.length > 1">
											<button 
												type="button" 
												class="btn btn-danger btn-sm w-100" 
												@click="removeMaterial(index)"
												title="Remove Material"
											>
												<i class="icofont icofont-trash"></i>
											</button>
										</div>
									</div>
								</div>
								<div class="col-md-12 form-group">
									<button 
										type="button" 
										class="btn btn-secondary btn-sm" 
										@click="addMaterial"
									>
										<i class="icofont icofont-plus me-1"></i> Add More Material
									</button>
								</div>
							</div>
							<div class="modal-footer">
								<button type="submit" class="btn btn-primary" :disabled="isSubmittingComponent">
									<span v-if="isSubmittingComponent">
										<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
										Submitting...
									</span>
									<span v-else>Update</span>
								</button>
								<button class="btn btn-light" type="button" @click="closeComponentUpdateModal()" :disabled="isSubmittingComponent">Close</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>

		<!-- To Manufacturer Modal -->
		<div class="modal fade" id="toManufacturerModal" tabindex="-1" aria-labelledby="toManufacturerModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="toManufacturerModalLabel">To Manufacturer</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<form @submit.prevent="submitToManufacturer" enctype="multipart/form-data">
								<div class="col-md-12 form-group mt-2">
								<label class="control-label">Choose Vendor<span class="text-danger">*</span></label>
								<select class="form-select" v-model="vendor_id">
									<option value="">--Select Vendor--</option>
									<option v-for="vendor in vendors" :key="vendor.id" :value="vendor.id">
										{{ vendor.name }}
										</option>
									</select>
								</div>
							<div class="modal-footer">
								<button type="submit" class="btn btn-primary" :disabled="isSubmittingManufacturer">
									<span v-if="isSubmittingManufacturer">
										<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
										Submitting...
									</span>
									<span v-else>Update</span>
								</button>
								<button class="btn btn-light" type="button" @click="closeToManufacturerModal()" :disabled="isSubmittingManufacturer">Close</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>

		<!-- SIM Change Modal -->
		<div class="modal fade" id="simChangeModal" tabindex="-1" aria-labelledby="simChangeModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="simChangeModalLabel">SIM Change</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<form @submit.prevent="submitSimChange" enctype="multipart/form-data">
							<div class="col-md-12 form-group mb-2 mt-2">
								<div class="form-check">
									<input
										id="continueCurrentIccid"
										class="form-check-input"
										type="checkbox"
										v-model="continue_with_current_iccid"
										@change="onContinueCurrentIccidChange"
									/>
									<label class="form-check-label" for="continueCurrentIccid">
										Continue with current iccid
									</label>
								</div>
								<div v-if="sim_change_status == 2 && current_sim_iccid" class="mt-1">
									<span><b>Current ICCID:</b> {{ current_sim_iccid }}</span>
								</div>
							</div>
							<div class="col-md-12 form-group mb-2" v-if="sim_change_status == 1">
								<label class="control-label">Select ICCID<span class="text-danger">*</span></label>
								<div class="position-relative">
									<input 
										v-model="iccid_search" 
										class="form-control" 
										placeholder="Search ICCID..."
										@input="searchIccid"
										@focus="showIccidSuggestions = true"
										@blur="hideIccidSuggestions"
										required
									/>
									<div v-if="showIccidSuggestions && filteredIccidList.length > 0" class="position-absolute w-100 bg-white border rounded shadow-sm" style="z-index: 1000; max-height: 200px; overflow-y: auto;">
										<div 
											v-for="iccid in filteredIccidList" 
											:key="iccid.id"
											class="p-2 border-bottom cursor-pointer hover-bg-light"
											@click="selectIccid(iccid)"
											style="cursor: pointer;"
										>
											{{ iccid.iccid }}
										</div>
									</div>
								</div>
							</div>
							<div class="col-md-6 form-group mb-2" v-if="selectedIccid">
								<label class="control-label">SIM 1<span class="text-danger">*</span></label>
								<input v-model="selectedIccid.msisdn_1" class="form-control" disabled/>
							</div>
							<div class="col-md-6 form-group mb-2" v-if="selectedIccid">
								<label class="control-label">SIM 2<span class="text-danger">*</span></label>
								<input v-model="selectedIccid.msisdn_2" class="form-control" disabled/>
							</div>
							<div class="col-md-12">
								<div class="form-group mb-2">
									<label class="control-label">Year Of Expiry<span class="text-danger">*</span></label>
									<select class="form-select" v-model="certificate_validity" :class="{ 'is-invalid': errors.year_of_expiry }">
										<option value="">--select--</option>
										<option value="1">1 Year</option>
										<option value="2">2 Year</option>
									</select>
									<div v-if="errors.certificate_validity" class="invalid-feedback">{{ errors.certificate_validity }}</div>
								</div>
							</div>
							<div class="col-md-12 form-group mb-2">
								<label class="control-label">Remarks <span v-if="sim_change_status == 2" class="text-danger">*</span></label>
								<textarea
									class="form-control"
									placeholder="Enter remarks"
									v-model="sim_change_remarks"
									:class="{ 'is-invalid': errors.sim_change_remarks }"
								></textarea>
								<div v-if="errors.sim_change_remarks" class="invalid-feedback">{{ errors.sim_change_remarks }}</div>
							</div>
							<div class="modal-footer">
								<button type="submit" class="btn btn-primary" :disabled="isSubmittingSim">
									<span v-if="isSubmittingSim">
										<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
										Submitting...
									</span>
									<span v-else>Update</span>
								</button>
								<button class="btn btn-light" type="button" @click="closeSimChangeModal()" :disabled="isSubmittingSim">Close</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>

		<!-- Completed Modal -->
		<div class="modal fade" id="completedModal" tabindex="-1" aria-labelledby="completedModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="completedModalLabel">Completed</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<form @submit.prevent="submitCompleted" enctype="multipart/form-data">
							<div class="col-md-12 mb-3" v-if="completedModalService && (completedModalService.payment_status != null || completedModalService.total_amount != null)">
								<div class="alert alert-light border">
									<strong>From service:</strong>
									<span v-if="completedModalService.payment_status != null">Payment Status: {{ paymentStatusLabel(completedModalService.payment_status) }}</span>
									<span v-if="completedModalService.payment_status != null && completedModalService.total_amount != null"> | </span>
									<span v-if="completedModalService.total_amount != null">Total Amount: {{ completedModalService.total_amount }}</span>
								</div>
							</div>

							<!-- Same flow as complaint_details.vue — Completed (recharge-style) -->
							<div class="col-md-12 form-group mt-2">
								<label class="control-label">Payment Status<span class="text-danger">*</span></label>
								<select class="form-select" v-model="payment_status" @change="onCompletedPaymentStatusChange">
									<option value="">--Select Payment Status--</option>
									<option value="1">Received</option>
									<option value="2">Not Received</option>
									<option value="4">Free Service</option>
									<option value="5">Advance</option>
								</select>
							</div>

							<div class="col-md-12 form-group mt-2" v-if="payment_status === '4'">
								<label class="control-label">Remarks</label>
								<textarea class="form-control" placeholder="Optional remarks" v-model="remarks"></textarea>
							</div>

							<div class="col-md-12 form-group mt-2" v-if="payment_status && payment_status !== '4'">
								<label class="control-label">Total Amount<span class="text-danger">*</span></label>
								<input class="form-control" type="number" step="0.01" min="0" placeholder="Enter total amount" v-model="cost"/>
							</div>

							<div class="col-md-12 form-group mt-2" v-if="payment_status && payment_status !== '4'">
								<label class="control-label">Remarks<span class="text-danger">*</span></label>
								<textarea class="form-control" placeholder="Enter remarks" v-model="remarks"></textarea>
							</div>

							<div class="col-md-12 form-group mt-2" v-if="payment_status && payment_status !== '4'">
								<label class="control-label">Payment By<span class="text-danger">*</span></label>
								<select class="form-select" v-model="payment_by" @change="onCompletedPaymentByChange">
									<option value="">--Select Payment By--</option>
									<option value="1">Dealer</option>
									<option value="2">Customer</option>
								</select>
							</div>

							<div class="col-md-12 form-group mt-2" v-if="payment_status && payment_status !== '4' && payment_by == '1'">
								<label class="control-label">Payment Dealer<span class="text-danger">*</span></label>
								<div class="position-relative">
									<input
										class="form-control"
										type="text"
										placeholder="Search dealer..."
										v-model="paymentDealerSearch"
										@input="searchPaymentDealer"
										@focus="showPaymentDealerSuggestions = true"
										@blur="hidePaymentDealerSuggestions"
										autocomplete="off"
									/>
									<ul
										v-if="showPaymentDealerSuggestions && filteredPaymentDealers.length"
										class="list-group position-absolute w-100"
										style="z-index: 1056; max-height: 200px; overflow-y: auto;"
									>
										<li
											v-for="dealer in filteredPaymentDealers"
											:key="dealer.id"
											class="list-group-item list-group-item-action"
											@mousedown.prevent="selectPaymentDealer(dealer)"
										>
											{{ dealer.first_name }}
										</li>
									</ul>
								</div>
								<div v-if="selectedPaymentDealer" class="mt-2">
									<small class="text-success">
										<i class="icofont icofont-check-circled me-1"></i>
										Selected: <strong>{{ selectedPaymentDealer.first_name }}</strong>
									</small>
								</div>
							</div>

							<div class="col-md-12 form-group mt-2" v-if="payment_status && payment_status !== '4' && payment_by == '2'">
								<label class="control-label">Customer<span class="text-danger">*</span></label>
								<div class="position-relative">
									<input
										class="form-control"
										type="text"
										placeholder="Search customer..."
										v-model="paymentCustomerSearch"
										@input="searchPaymentCustomer"
										@focus="showPaymentCustomerSuggestions = true"
										@blur="hidePaymentCustomerSuggestions"
										autocomplete="off"
									/>
									<ul
										v-if="showPaymentCustomerSuggestions && filteredPaymentCustomers.length"
										class="list-group position-absolute w-100"
										style="z-index: 1056; max-height: 200px; overflow-y: auto;"
									>
										<li
											v-for="cust in filteredPaymentCustomers"
											:key="cust.id"
											class="list-group-item list-group-item-action"
											@mousedown.prevent="selectPaymentCustomer(cust)"
										>
											{{ cust.company_name }}
										</li>
									</ul>
								</div>
								<div v-if="selectedPaymentCustomer" class="mt-2">
									<small class="text-success">
										<i class="icofont icofont-check-circled me-1"></i>
										Selected: <strong>{{ selectedPaymentCustomer.company_name }}</strong>
									</small>
								</div>
							</div>

							<div class="col-md-12 form-group mt-2" v-if="payment_user_id && payment_status === '2'">
								<div class="form-check">
									<input
										id="deduct_from_credit_list"
										class="form-check-input"
										type="checkbox"
										v-model="deduct_from_credit"
									/>
									<label class="form-check-label" for="deduct_from_credit_list">Deduct from credit balance</label>
								</div>
							</div>

							<div class="col-md-12 form-group mt-2" v-if="payment_user_id && showCompletedPaymentCredit">
								<label class="control-label">Amount from credit<span class="text-danger">*</span></label>
								<input
									class="form-control"
									type="number"
									step="0.01"
									min="0"
									placeholder="Enter credit amount"
									v-model="amount_from_credit"
								/>
								<div v-if="userCreditLoading" class="mt-2"><small class="text-success">Loading...</small></div>
								<div v-else-if="userCredit && userCredit.credit_available_amount != null" class="mt-2">
									<small class="text-success">Credit available: ₹{{ userCredit.credit_available_amount }}</small>
								</div>
								<div v-else class="mt-2"><small class="text-muted">—</small></div>
								<div v-if="userCreditError" class="text-danger small mt-1">{{ userCreditError }}</div>
							</div>

							<div class="col-md-12 form-group mt-2" v-if="payment_user_id && payment_status === '1'">
								<label class="control-label">Payment Type<span class="text-danger">*</span></label>
								<select class="form-select" v-model="payment_type" @change="onCompletedPaymentTypeChange">
									<option value="">--Select Payment Type--</option>
									<option value="1">Cash</option>
									<option value="2">Online</option>
									<option value="3">Both</option>
									<option value="4">Advance</option>
								</select>
							</div>

							<div class="col-md-12 form-group mt-2" v-if="payment_user_id && payment_status === '1' && payment_type && payment_type !== '4'">
								<label class="control-label">Payment Date<span class="text-danger">*</span></label>
								<input class="form-control" type="date" v-model="payment_date" />
							</div>

							<div class="col-md-12 form-group mt-2" v-if="payment_user_id && payment_status === '1' && (payment_type == '2' || payment_type == '3')">
								<label class="control-label">Select Bank<span class="text-danger">*</span></label>
								<select class="form-select" v-model="bank_account_id">
									<option value="">--Select Bank--</option>
									<option v-for="bank in banks" :key="bank.id" :value="bank.id">
										{{ bank.bank_name }} ({{ bank.account_number }})
									</option>
								</select>
							</div>

							<div class="row" v-if="payment_user_id && payment_status === '1' && (payment_type == '2' || payment_type == '3')">
								<div class="col-md-6 form-group mt-2">
									<label class="control-label">Online Amount<span class="text-danger">*</span></label>
									<input class="form-control" type="number" step="0.01" min="0" placeholder="Enter online amount" v-model="online_amount"/>
								</div>
								<div class="col-md-6 form-group mt-2">
									<label class="control-label">Payment ID<span class="text-danger">*</span></label>
									<input class="form-control" type="text" placeholder="Enter payment ID" v-model="payment_id"/>
								</div>
							</div>

							<div class="col-md-12 form-group mt-2" v-if="payment_user_id && payment_status === '1' && (payment_type == '1' || payment_type == '3')">
								<label class="control-label">Cash Amount<span class="text-danger">*</span></label>
								<input class="form-control" type="number" step="0.01" min="0" placeholder="Enter cash amount" v-model="cash_amount"/>
							</div>

							<div class="col-md-12 mt-2" v-if="payment_user_id && payment_status === '1' && payment_type && payment_type !== '4' && getCompletedPaymentBreakdown()">
								<div class="card border-light">
									<div class="card-body p-2">
										<div class="row text-center">
											<div class="col-md-3">
												<small class="text-muted">Total Amount</small>
												<div class="fw-bold">₹{{ getCompletedPaymentBreakdown().total }}</div>
											</div>
											<div class="col-md-3" v-if="payment_type === '2' || payment_type === '3'">
												<small class="text-muted">Online</small>
												<div class="fw-bold">₹{{ getCompletedPaymentBreakdown().online }}</div>
											</div>
											<div class="col-md-3" v-if="payment_type === '1' || payment_type === '3'">
												<small class="text-muted">Cash</small>
												<div class="fw-bold">₹{{ getCompletedPaymentBreakdown().cash }}</div>
											</div>
											<div class="col-md-3">
												<small class="text-muted">Status</small>
												<div class="fw-bold" :class="getCompletedPaymentBreakdown().statusClass">
													{{ getCompletedPaymentBreakdown().statusLabel }}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="modal-footer">
								<button type="submit" class="btn btn-primary" :disabled="isSubmittingCompleted">
									<span v-if="isSubmittingCompleted">
										<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
										Submitting...
									</span>
									<span v-else>Update</span>
								</button>
								<button class="btn btn-light" type="button" @click="closeCompletedModal()" :disabled="isSubmittingCompleted">Close</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>

		<UpdateServiceDataModal
			ref="updateServiceModal"
			modal-id="updateServiceDataModalComplaintList"
			@updated="fetchServices(active_page_url || undefined)"
		/>

	</div>
</template>

<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
import Product_stock from '../reports/raw_material_stock.vue';
import UpdateServiceDataModal from '@/components/complaint/UpdateServiceDataModal.vue'

export default {
		name: "Pincode Page",
		components: {
			DynamicModal,
			UpdateServiceDataModal,
		},
		setup(){
			let dynamicmodal;
			let componentUpdateModal;
			let toManufacturerModal;
			let simChangeModal;
			let completedModal;

			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
				componentUpdateModal = new Modal(document.getElementById('componentUpdateModal'));
				toManufacturerModal = new Modal(document.getElementById('toManufacturerModal'));
				simChangeModal = new Modal(document.getElementById('simChangeModal'));
				completedModal = new Modal(document.getElementById('completedModal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			const showComponentUpdateModal = () => {
				if (componentUpdateModal) {
					componentUpdateModal.show();
				} else {
					componentUpdateModal = new Modal(document.getElementById('componentUpdateModal'));
					componentUpdateModal.show();
				}
			}

			const hideComponentUpdateModal = () => {
				if (componentUpdateModal) {
					componentUpdateModal.hide();
				}
			}

			const showToManufacturerModal = () => {
				if (toManufacturerModal) {
					toManufacturerModal.show();
				} else {
					toManufacturerModal = new Modal(document.getElementById('toManufacturerModal'));
					toManufacturerModal.show();
				}
			}

			const hideToManufacturerModal = () => {
				if (toManufacturerModal) {
					toManufacturerModal.hide();
				}
			}

			const showSimChangeModal = () => {
				if (simChangeModal) {
					simChangeModal.show();
				} else {
					simChangeModal = new Modal(document.getElementById('simChangeModal'));
					simChangeModal.show();
				}
			}

			const hideSimChangeModal = () => {
				if (simChangeModal) {
					simChangeModal.hide();
				}
			}

			const showCompletedModal = () => {
				if (completedModal) {
					completedModal.show();
				} else {
					completedModal = new Modal(document.getElementById('completedModal'));
					completedModal.show();
				}
			}

			const hideCompletedModal = () => {
				if (completedModal) {
					completedModal.hide();
				}
			}

			return {
				showModal, hideModal,
				showComponentUpdateModal, hideComponentUpdateModal,
				showToManufacturerModal, hideToManufacturerModal,
				showSimChangeModal, hideSimChangeModal,
				showCompletedModal, hideCompletedModal
			}
		},
		
		data() {
			return {
				
				modal_title: "Update Service Status",
				button_title: "Save",

				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				errors: {},
				status:"",

                button_title: "Save",
                name: "",
				technician: "",

				complaint_status: 1,
				material_change: '',
				product_id: '',
				quantity: '',
				cost: '',
				payment_status: '',
				payment_type: '',
				payment_date: '',
				online_amount: '',
				cash_amount: '',
				payment_id: '',
				remarks: '',
				services:[],
				
				// Dynamic data properties
				complaints: [],
				all_complaints: [], // Store all complaints for filtering
				status_filter: "",
				search_term: "",
				loading: false,
				selected_complaint_id: null,
				
				// Component Update Modal Data
				componentMaterials: [],
				rawMaterials: [],
				isSubmittingComponent: false,
				currentServiceStatus: null,
				currentVendorName: "",

				// To Manufacturer Modal Data
				vendor_id: "",
				vendors: [],
				isSubmittingManufacturer: false,

				// SIM Change Modal Data
				iccid_search: '',
				selectedIccid: null,
				showIccidSuggestions: false,
				filteredIccidList: [],
				continue_with_current_iccid: false,
				sim_change_status: 1,
				sim_change_remarks: '',
				current_sim_iccid: '',
				certificate_validity: '',
				isSubmittingSim: false,

				// Completed Modal Data (aligned with complaint_details.vue)
				isSubmittingCompleted: false,
				completedModalService: null,
				payment_by: "",
				payment_user_id: "",
				bank_account_id: "",
				amount_from_credit: "",
				deduct_from_credit: false,
				paymentDealerSearch: "",
				showPaymentDealerSuggestions: false,
				selectedPaymentDealer: null,
				dealers: [],
				companies: [],
				banks: [],
				paymentCustomerSearch: "",
				showPaymentCustomerSuggestions: false,
				selectedPaymentCustomer: null,
				userCredit: null,
				userCreditLoading: false,
				userCreditError: "",
				prevShowUserCredit: false,

				start_date: '',
				end_date: new Date().toISOString().slice(0, 10),
				max: new Date().toISOString().slice(0, 10),
				total: 0,
				excel_loading: false,
			};
		},
		computed: {
			// Show number of results
			resultsCount() {
				return this.complaints.length;
			},
			filteredPaymentDealers() {
				if (!this.paymentDealerSearch || !this.paymentDealerSearch.trim()) return this.dealers;
				const q = this.paymentDealerSearch.toLowerCase();
				return this.dealers.filter((d) => (d.first_name || "").toLowerCase().includes(q));
			},
			filteredPaymentCustomers() {
				if (!this.paymentCustomerSearch || !this.paymentCustomerSearch.trim()) return this.companies;
				const q = this.paymentCustomerSearch.toLowerCase();
				return this.companies.filter((c) => (c.company_name || "").toLowerCase().includes(q));
			},
			showCompletedPaymentCredit() {
				if (!this.payment_user_id) return false;
				if (this.payment_status === "5") return true;
				if (this.payment_status === "2" && this.deduct_from_credit) return true;
				if (this.payment_status === "1" && this.payment_type === "4") return true;
				return false;
			},
		},
		watch: {
			payment_user_id: "maybeFetchCompletePaymentCredit",
			payment_status: "maybeFetchCompletePaymentCredit",
			deduct_from_credit: "maybeFetchCompletePaymentCredit",
			payment_type: "maybeFetchCompletePaymentCredit",
		},
		created() {
			this.fetchServices();
			this.fetchDealers();
			this.fetchCompanies();
			this.fetchBankAccounts();
		},
		methods: {

			openUpdateServiceModal(service) {
				this.$refs.updateServiceModal?.open(service);
			},

			formatDealerName(service) {
				const dealerName = service?.dealer_name;
				if (dealerName != null && String(dealerName).trim() !== '') {
					return dealerName;
				}
				const parts = [service?.dealer_first_name, service?.dealer_last_name].filter(Boolean);
				return parts.join(' ') || '-';
			},

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

			downloadServicesExcel() {
				if (!this.start_date || !this.end_date) return;

				this.getToken();
				const params = new URLSearchParams({
					keyword: String(this.keyword || "").trim(),
					status: this.status || "",
					from_date: this.start_date,
					to_date: this.end_date,
				});
				this.excel_loading = true;
				this.$axios
					.get("/staffs/servicesExcel?" + params.toString(), { headers: { Authorization: "Bearer " + this.token }, responseType: "blob" })
					.then((response) => {
						const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
						const link = document.createElement("a");
						link.href = window.URL.createObjectURL(blob);
						link.download = "complaints_" + this.start_date + "_" + this.end_date + ".xlsx";
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						window.URL.revokeObjectURL(link.href);
					})
					.catch((err) => console.log(err))
					.finally(() => {
						this.excel_loading = false;
					});
			},

			fetchServices(page_url = null) {
				this.getToken();
				let url = "/staffs/services?limit=" + this.listing_length  +  "&keyword=" + this.keyword +  "&status=" + this.status + "&from_date=" + this.start_date + "&to_date=" + this.end_date;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.services = responseData.services.data;
						this.all_complaints =responseData.services.data;
						this.pagination = responseData.services.links;
						this.from = responseData.services.from;
						this.to = responseData.services.to;
						this.total = responseData.services.total;
						
					})
					.catch((err) => console.log(err));
			},

			fetchDealers() {
				this.getToken();
				this.$axios
					.get("/staffs/dealers", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						this.dealers = res.data?.data || [];
					})
					.catch(() => {
						this.dealers = [];
					});
			},

			fetchCompanies() {
				this.getToken();
				this.$axios
					.get("/staffs/companies", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						const data = res.data.data || res.data;
						this.companies = Array.isArray(data) ? data : data?.data || [];
					})
					.catch(() => {
						this.companies = [];
					});
			},

			fetchBankAccounts() {
				this.getToken();
				this.$axios
					.get("/staffs/bankAccounts", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						const data = res.data.data || res.data;
						this.banks = Array.isArray(data) ? data : data?.data || [];
					})
					.catch(() => {
						this.banks = [];
					});
			},

			getSelectedUserId(entity) {
				return entity && entity.user_id ? String(entity.user_id) : "";
			},

			openModal() {
				this.showModal();
			},

			/** DynamicModal: payment_type 1=Online, 2=Cash, 3=Both */
			onPaymentTypeChange() {
				if (this.payment_type === "2") {
					this.online_amount = "";
					this.payment_id = "";
				} else if (this.payment_type === "1") {
					this.cash_amount = "";
				} else if (this.payment_type === "3") {
					// keep both
				}
			},

			getPaymentBreakdown() {
				if (!this.payment_type || this.payment_status !== "received") return null;
				const total = parseFloat(this.cost) || 0;
				const online = parseFloat(this.online_amount) || 0;
				const cash = parseFloat(this.cash_amount) || 0;
				let paid = 0;
				if (this.payment_type === "1") paid = online;
				else if (this.payment_type === "2") paid = cash;
				else if (this.payment_type === "3") paid = online + cash;
				else return null;
				const eps = 0.01;
				const diff = paid - total;
				let statusLabel = "Partial";
				let statusClass = "text-warning";
				if (Math.abs(diff) < eps) {
					statusLabel = "Full";
					statusClass = "text-success";
				} else if (diff > eps) {
					statusLabel = "Advance";
					statusClass = "text-info";
				}
				return { total, online, cash, statusLabel, statusClass };
			},

			closeModal() {
				this.hideModal();
			},

            updateStatus(id) {
                this.errors = {};
				this.complaint_status = 1;
                this.material_change = "";
				this.product_id = "";
				this.quantity = "";
				this.cost = "";
				this.payment_status = "";
				this.payment_type = "";
				this.online_amount = "";
				this.cash_amount = "";
				this.payment_id = "";
				this.remarks = "";
				this.modal_title = "Update Service Status";
				this.button_title = "Save";
				this.selected_complaint_id = id;
				this.showModal();
            },

			deleteService(id) {
				this.$swal({
					icon: 'warning',
					title: 'Confirm',
					text: 'Are you sure you want to delete this pending service?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: 'center',
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
				}).then((result) => {
					if (result.value) {
						this.getToken();
						const config = {
							headers: {
								Authorization: 'Bearer ' + this.token,
							},
						};
						this.$axios
							.post('/staffs/deleteService', { service_id: id }, config)
							.then((response) => {
								if (response.data.status === true || response.data.status === 'true') {
									this.$swal('', response.data.message || 'Service deleted successfully', 'success');
								} else {
									this.$swal('', response.data.message || 'Failed to delete service', 'error');
								}
								this.fetchServices();
							})
							.catch((error) => {
								this.$swal('', this.$getApiErrorMessage(error, 'Something went wrong'), 'error');
							});
					}
				});
			},

			markAsReceived(id) {
				this.$swal({
					icon: 'warning',
					title: 'Confirm',
					text: 'Are you sure you want to mark the device Received as Renewal Replacement?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: 'center',
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
				}).then((result) => {
					if (result.value) {
						this.getToken();
						const config = {
							headers: {
								Authorization: 'Bearer ' + this.token,
							},
						};
						this.$axios
							.get('/staffs/markAsReceived?service_id=' + id, config)
							.then((response) => {
								if (response.data.status === true || response.data.status === 'true') {
									this.$swal('', response.data.message || 'Marked as received successfully', 'success');
								} else {
									this.$swal('', response.data.message || 'Failed to mark as received', 'error');
								}
								this.fetchServices();
							})
							.catch((error) => {
								if (error.response?.data?.message) {
									this.$swal('', error.response.data.message, 'error');
								} else {
									this.$swal('', 'Something went wrong', 'error');
								}
							});
					}
				});
			},

			assignToSpeedtech(id) {
					this.delete = false;
					this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to assign this service to Speedtech?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
                     this.getToken();
                     const config = {
                        headers: {
                              'Authorization': 'Bearer ' + this.token,
                        }
                     };
                     this.$axios
                     .get('/staffs/assignToSpeedtech?service_id=' + id, config)
                     .then(response => {
                        if(response.data.status) {
                           this.$swal("", response.data.message, "success");
                        } else {
                           this.$swal("", response.data.message, "error");
                        }
                        this.fetchServices();
                     })
                     .catch(error => {
                           if(error.response){
                              if(error.response.data.message){
                                 this.$swal("", error.response.data.message, "error");
                              } else {
                                 this.$swal("", "Something went wrong", "error");
                              }
                           } else {
                              this.$swal("", "Something went wrong", "error");
                           }
                           
                     });
					}
					
				});
			},

			// ========== Component Update Modal Methods ==========
			openComponentUpdateModal(id) {
				this.selected_complaint_id = id;
				
				// Get service details to check status and vendor
				const service = this.services.find(s => s.id === id);
				if (service) {
					this.currentServiceStatus = service.status;
					this.currentVendorName = service.vendor_name || service.vendor?.name || "";
				} else {
					this.currentServiceStatus = null;
					this.currentVendorName = "";
				}
				
				this.componentMaterials = [{
					search: '',
					selectedMaterial: null,
					qty: 1,
					showSuggestions: false,
					filteredList: []
				}];
				this.isSubmittingComponent = false;
				this.fetchRawMaterials();
				this.showComponentUpdateModal();
			},

			closeComponentUpdateModal() {
				this.hideComponentUpdateModal();
				this.clearComponentUpdateForm();
			},

			clearComponentUpdateForm() {
				this.componentMaterials = [];
				this.selected_complaint_id = null;
				this.isSubmittingComponent = false;
				this.currentServiceStatus = null;
				this.currentVendorName = "";
			},

			fetchRawMaterials() {
				this.getToken();
				this.$axios
					.get("/staffs/getRawMaterials", { 
						headers: { Authorization: "Bearer " + this.token } 
					})
					.then((res) => {
						if (res.data.status === true || res.data.status === 'true') {
							this.rawMaterials = res.data.data || [];
						} else {
							this.rawMaterials = [];
						}
					})
					.catch((err) => {
						console.error('Error fetching raw materials:', err);
						this.rawMaterials = [];
					});
			},

			searchMaterial(index) {
				const material = this.componentMaterials[index];
				if (!material.search || material.search.trim() === '') {
					material.filteredList = [];
					return;
				}

				const searchTerm = material.search.toLowerCase();
				material.filteredList = this.rawMaterials.filter(mat => {
					const name = (mat.raw_material_name || '').toLowerCase();
					const desc = (mat.description || '').toLowerCase();
					return name.includes(searchTerm) || desc.includes(searchTerm);
				});
			},

			selectMaterial(index, mat) {
				const material = this.componentMaterials[index];
				material.search = mat.raw_material_name;
				material.selectedMaterial = mat;
				material.showSuggestions = false;
				material.filteredList = [];
			},

			hideMaterialSuggestions(index) {
				setTimeout(() => {
					this.componentMaterials[index].showSuggestions = false;
				}, 200);
			},

			addMaterial() {
				this.componentMaterials.push({
					search: '',
					selectedMaterial: null,
					qty: 1,
					showSuggestions: false,
					filteredList: []
				});
			},

			removeMaterial(index) {
				if (this.componentMaterials.length > 1) {
					this.componentMaterials.splice(index, 1);
				}
			},

			submitComponentUpdate() {
				if (this.isSubmittingComponent) return;

				if (!this.componentMaterials || this.componentMaterials.length === 0) {
					this.$swal('Error', 'Please add at least one material', 'error');
					return;
				}

				for (let i = 0; i < this.componentMaterials.length; i++) {
					const mat = this.componentMaterials[i];
					if (!mat.selectedMaterial) {
						this.$swal('Error', `Please select material for row ${i + 1}`, 'error');
					return;
					}
					if (!mat.qty || mat.qty < 1) {
						this.$swal('Error', `Please enter valid quantity for row ${i + 1}`, 'error');
						return;
					}
				}

				this.isSubmittingComponent = true;
				this.getToken();

				const payload = {
					service_id: this.selected_complaint_id,
					raw_materials: this.componentMaterials.map(mat => ({
						raw_material_id: mat.selectedMaterial.id,
						qty: mat.qty
					}))
				};

				this.$axios.post('/staffs/componentReplacement', payload, {
					headers: { Authorization: "Bearer " + this.token }
				})
				.then(res => {
					this.isSubmittingComponent = false;
					this.$swal('Success', res.data.message || 'Component updated successfully', 'success');
					this.closeComponentUpdateModal();
					this.fetchServices();
				})
				.catch(err => {
					this.isSubmittingComponent = false;
					this.$swal('Error', err.response?.data?.message || 'Failed to update component', 'error');
				});
			},

			// ========== To Manufacturer Modal Methods ==========
			openToManufacturerModal(id) {
				this.selected_complaint_id = id;
				this.vendor_id = "";
				this.fetchVendors();
				this.showToManufacturerModal();
			},

			closeToManufacturerModal() {
				this.hideToManufacturerModal();
				this.vendor_id = "";
				this.selected_complaint_id = null;
				this.isSubmittingManufacturer = false;
			},

			fetchVendors() {
				this.getToken();
				this.$axios
					.get('/staffs/vendorsList', {
						headers: { Authorization: "Bearer " + this.token }
					})
					.then((res) => {
						if (res.data.status === true || res.data.status === 'true') {
							this.vendors = res.data.data;
						} else {
							this.vendors = [];
						}
					})
					.catch((err) => {
						console.error('Error fetching vendors:', err);
						this.vendors = [];
					});
			},

			submitToManufacturer() {
				if (this.isSubmittingManufacturer) return;

				if (!this.vendor_id) {
					this.$swal('Error', 'Please select vendor', 'error');
					return;
				}

				this.isSubmittingManufacturer = true;
				this.getToken();

				const payload = {
						service_id: this.selected_complaint_id,
					vendor_id: this.vendor_id
				};

				this.$axios.post('/staffs/assignToVendor', payload, {
					headers: { Authorization: "Bearer " + this.token }
				})
				.then(res => {
					this.isSubmittingManufacturer = false;
					this.$swal('Success', res.data.message || 'Assigned to vendor successfully', 'success');
					this.closeToManufacturerModal();
							this.fetchServices();
				})
				.catch(err => {
					this.isSubmittingManufacturer = false;
					this.$swal('Error', err.response?.data?.message || 'Failed to assign vendor', 'error');
				});
			},

			// ========== SIM Change Modal Methods ==========
			openSimChangeModal(id) {
				this.selected_complaint_id = id;
				const service = this.services.find(s => s.id == id);
				this.certificate_validity = (service && service.certificate_validity != null && service.certificate_validity !== '') ? String(service.certificate_validity) : '';
				this.sim_change_status = (service && service.sim_change_status != null && service.sim_change_status !== '') ? Number(service.sim_change_status) : 1;
				this.continue_with_current_iccid = this.sim_change_status === 2;
				this.sim_change_remarks = (service && service.sim_change_remarks != null) ? service.sim_change_remarks : '';
				this.current_sim_iccid = (service && service.iccid) ? service.iccid : '';
				this.iccid_search = "";
				this.selectedIccid = null;
				this.showIccidSuggestions = false;
				this.filteredIccidList = [];
				this.errors = {};
				this.isSubmittingSim = false;
				this.showSimChangeModal();
			},

			closeSimChangeModal() {
				this.hideSimChangeModal();
				this.clearSimChangeForm();
			},

			clearSimChangeForm() {
				this.iccid_search = "";
				this.selectedIccid = null;
				this.showIccidSuggestions = false;
				this.filteredIccidList = [];
				this.continue_with_current_iccid = false;
				this.sim_change_status = 1;
				this.sim_change_remarks = '';
				this.current_sim_iccid = '';
				this.certificate_validity = '';
				this.errors = {};
				this.selected_complaint_id = null;
				this.isSubmittingSim = false;
			},

			onContinueCurrentIccidChange() {
				this.sim_change_status = this.continue_with_current_iccid ? 2 : 1;
				if (this.sim_change_status === 2) {
					this.iccid_search = "";
					this.selectedIccid = null;
					this.showIccidSuggestions = false;
					this.filteredIccidList = [];
				}
			},

			searchIccid() {
				if (this.iccid_search.trim() === '') {
					this.filteredIccidList = [];
					return;
				}

				this.getToken();
				this.$axios.get('/staffs/fetchICCID', {
					params: { iccid: this.iccid_search },
					headers: { Authorization: `Bearer ${this.token}` }
				})
				.then((res) => {
					if (res.data.status === 'true') {
						this.filteredIccidList = res.data.data;
						} else {
						this.filteredIccidList = [];
						}
					})
				.catch((err) => {
					console.error('Error fetching ICCIDs:', err);
					this.filteredIccidList = [];
				});
			},

			selectIccid(iccid) {
				this.iccid_search = iccid.iccid;
				this.showIccidSuggestions = false;

				this.getToken();
				this.$axios.get('/staffs/getSimByICCID', {
					params: { iccid: iccid.iccid },
					headers: { Authorization: `Bearer ${this.token}` },
				})
				.then((res) => {
					if (res.data.status === 'true') {
						this.selectedIccid = res.data.data;
						} else {
						this.selectedIccid = null;
						this.$swal('Error', res.data.message || 'No SIM details found', 'error');
					}
				})
				.catch((err) => {
					console.error('Error fetching SIM details:', err);
					this.selectedIccid = null;
				});
			},

			hideIccidSuggestions() {
				setTimeout(() => {
					this.showIccidSuggestions = false;
				}, 200);
			},

			submitSimChange() {
				if (this.isSubmittingSim) return;
				this.errors = {};

				if (!this.certificate_validity) {
					this.$swal('Error', 'Please select year of expiry', 'error');
					return;
				}

				if (this.sim_change_status == 1 && !this.selectedIccid) {
					this.$swal('Error', 'Please select ICCID', 'error');
					return;
				}

				if (this.sim_change_status == 2 && !this.sim_change_remarks.trim()) {
					this.errors.sim_change_remarks = 'Remarks is required';
					this.$swal('Error', 'Please enter remarks', 'error');
					return;
				}

				// Get service IMEI from the service object
				const service = this.services.find(s => s.id === this.selected_complaint_id);
				if (!service) {
					this.$swal('Error', 'Service not found', 'error');
					return;
				}

				this.isSubmittingSim = true;
				this.getToken();

				const payload = {
					service_id: this.selected_complaint_id,
					sim_change_status: this.sim_change_status,
					iccid: this.sim_change_status == 1 ? this.selectedIccid.iccid : '',
					imei: service.imei,
					primary_number: this.sim_change_status == 1 ? (this.selectedIccid.msisdn_1 || '') : '',
					secondary_number: this.sim_change_status == 1 ? (this.selectedIccid.msisdn_2 || '') : '',
					network_provider: this.sim_change_status == 1 ? (this.selectedIccid.sim || '') : '',
					certificate_validity: this.certificate_validity || '',
					remarks: this.sim_change_remarks ? this.sim_change_remarks.trim() : ''
				};

				this.$axios.post('/staffs/updateDeviceSimDetails', payload, {
					headers: { Authorization: "Bearer " + this.token }
				})
				.then(res => {
					this.isSubmittingSim = false;
					this.$swal('Success', res.data.message || 'SIM changed successfully', 'success');
					this.closeSimChangeModal();
					this.fetchServices();
				})
				.catch(err => {
					this.isSubmittingSim = false;
					this.$swal('Error', err.response?.data?.message || 'Failed to change SIM', 'error');
				});
			},

			// ========== Completed Modal Methods (aligned with complaint_details.vue) ==========
			paymentStatusLabel(val) {
				if (val == null || val === "") return "—";
				const s = String(val);
				if (s === "1") return "Received";
				if (s === "2") return "Not Received";
				if (s === "4") return "Free Service";
				if (s === "5") return "Advance";
				return s;
			},

			initCompletedPaymentFromListService() {
				this.payment_by = "1";
				this.payment_status = "";
				this.payment_type = "";
				this.payment_user_id = "";
				this.bank_account_id = "";
				this.amount_from_credit = "";
				this.deduct_from_credit = false;
				this.online_amount = "";
				this.cash_amount = "";
				this.payment_id = "";
				this.selectedPaymentCustomer = null;
				this.paymentCustomerSearch = "";
				this.selectedPaymentDealer = null;
				this.paymentDealerSearch = "";
				this.userCredit = null;
				this.userCreditError = "";
				this.prevShowUserCredit = false;

				const service = this.completedModalService;
				const dealerId = service?.dealer_id != null ? service.dealer_id : null;
				if (dealerId != null) {
					// service.dealer_id is dealers.user_id (users.id), not dealers.id
					const dealer = this.dealers.find(
						(d) => d.user_id == dealerId || String(d.user_id) === String(dealerId)
					);
					if (dealer) {
						this.selectedPaymentDealer = dealer;
						this.paymentDealerSearch = dealer.first_name || "";
						this.payment_user_id = this.getSelectedUserId(dealer);
					} else {
						this.paymentDealerSearch = service?.dealer_name || "";
						this.selectedPaymentDealer = {
							id: dealerId,
							first_name: service?.dealer_name || "",
							user_id: dealerId,
						};
						this.payment_user_id = String(dealerId);
					}
				}
			},

			onCompletedPaymentStatusChange() {
				if (this.payment_status === "4") {
					this.payment_by = "";
					this.payment_user_id = "";
					this.payment_type = "";
					this.payment_date = "";
					this.bank_account_id = "";
					this.amount_from_credit = "";
					this.deduct_from_credit = false;
					this.selectedPaymentDealer = null;
					this.selectedPaymentCustomer = null;
					this.paymentDealerSearch = "";
					this.paymentCustomerSearch = "";
					return;
				}
				if (this.payment_status === "1") {
					if (!this.payment_date) {
						this.payment_date = this.todayIsoDate();
					}
				} else {
					this.payment_date = "";
				}
				if (this.payment_status !== "1") {
					this.payment_type = "";
					this.bank_account_id = "";
					this.online_amount = "";
					this.cash_amount = "";
					this.payment_id = "";
				}
				if (this.payment_status !== "2") {
					this.deduct_from_credit = false;
				}
				const useCredit =
					this.payment_status === "5" ||
					(this.payment_status === "2" && this.deduct_from_credit) ||
					(this.payment_status === "1" && this.payment_type === "4");
				if (!useCredit) {
					this.amount_from_credit = "";
				}
			},

			onCompletedPaymentByChange() {
				this.payment_user_id = "";
				this.payment_type = "";
				this.bank_account_id = "";
				this.amount_from_credit = "";
				this.deduct_from_credit = false;
				this.selectedPaymentDealer = null;
				this.selectedPaymentCustomer = null;
				this.paymentDealerSearch = "";
				this.paymentCustomerSearch = "";

				const service = this.completedModalService;
				if (this.payment_by === "1" && service?.dealer_id != null) {
					const dealerId = service.dealer_id;
					// service.dealer_id is dealers.user_id (users.id), not dealers.id
					const dealer = this.dealers.find(
						(d) => d.user_id == dealerId || String(d.user_id) === String(dealerId)
					);
					if (dealer) {
						this.selectedPaymentDealer = dealer;
						this.paymentDealerSearch = dealer.first_name || "";
						this.payment_user_id = this.getSelectedUserId(dealer);
					} else {
						this.paymentDealerSearch = service?.dealer_name || "";
						this.selectedPaymentDealer = {
							id: dealerId,
							first_name: service?.dealer_name || "",
							user_id: dealerId,
						};
						this.payment_user_id = String(dealerId);
					}
				}
			},

			onCompletedPaymentTypeChange() {
				if (this.payment_type === "2") {
					this.cash_amount = "";
				} else if (this.payment_type === "1") {
					this.online_amount = "";
					this.payment_id = "";
				} else if (this.payment_type === "4") {
					this.online_amount = "";
					this.cash_amount = "";
					this.payment_id = "";
				}
				if (!(this.payment_type === "2" || this.payment_type === "3")) {
					this.bank_account_id = "";
				}
			},

			async maybeFetchCompletePaymentCredit() {
				const nowVisible = this.showCompletedPaymentCredit;
				const wasVisible = this.prevShowUserCredit;

				if (!nowVisible) {
					this.userCredit = null;
					this.userCreditError = "";
					this.userCreditLoading = false;
					this.amount_from_credit = "";
					this.prevShowUserCredit = nowVisible;
					return;
				}
				if (!this.payment_user_id) return;

				if (!wasVisible) {
					this.amount_from_credit = this.cost || "";
				}

				await this.fetchCompletePaymentUserCredit();
				this.prevShowUserCredit = nowVisible;
			},

			async fetchCompletePaymentUserCredit() {
				try {
					this.getToken();
					this.userCreditLoading = true;
					this.userCreditError = "";

					const response = await this.$axios.get("/staffs/getUserCredit", {
						params: { user_id: this.payment_user_id },
						headers: { Authorization: "Bearer " + this.token },
					});

					const ok = response.data?.status === true || response.data?.status === "true";
					if (!ok) {
						this.userCredit = null;
						this.userCreditError = response.data?.message || "Failed to fetch credit balance";
						return;
					}

					this.userCredit = response.data?.data?.user_credit || null;
				} catch (e) {
					this.userCredit = null;
					this.userCreditError = e?.response?.data?.message || "Failed to fetch credit balance";
				} finally {
					this.userCreditLoading = false;
				}
			},

			searchPaymentDealer() {
				this.showPaymentDealerSuggestions = true;
			},
			hidePaymentDealerSuggestions() {
				setTimeout(() => {
					this.showPaymentDealerSuggestions = false;
				}, 200);
			},
			selectPaymentDealer(dealer) {
				const userId = this.getSelectedUserId(dealer);
				if (!userId) {
					this.$swal("Error", "Selected dealer has no linked user account", "error");
					return;
				}
				this.selectedPaymentDealer = dealer;
				this.paymentDealerSearch = dealer.first_name;
				this.showPaymentDealerSuggestions = false;
				this.payment_user_id = userId;
			},

			searchPaymentCustomer() {
				this.showPaymentCustomerSuggestions = true;
			},
			hidePaymentCustomerSuggestions() {
				setTimeout(() => {
					this.showPaymentCustomerSuggestions = false;
				}, 200);
			},
			selectPaymentCustomer(cust) {
				this.selectedPaymentCustomer = cust;
				this.paymentCustomerSearch = cust.company_name;
				this.showPaymentCustomerSuggestions = false;
				this.payment_user_id = this.getSelectedUserId(cust);
			},

			getCompletedPaymentBreakdown() {
				if (this.payment_status !== "1" || !this.payment_type || this.payment_type === "4") return null;

				const total = parseFloat(this.cost) || 0;
				const online = parseFloat(this.online_amount) || 0;
				const cash = parseFloat(this.cash_amount) || 0;

				let paid = 0;
				if (this.payment_type === "2") paid = online;
				else if (this.payment_type === "1") paid = cash;
				else if (this.payment_type === "3") paid = online + cash;
				else return null;

				const eps = 0.01;
				const diff = paid - total;
				let statusLabel = "Partial";
				let statusClass = "text-warning";
				if (Math.abs(diff) < eps) {
					statusLabel = "Full";
					statusClass = "text-success";
				} else if (diff > eps) {
					statusLabel = "Advance";
					statusClass = "text-info";
				}

				return { total, online, cash, statusLabel, statusClass };
			},

			openCompletedModal(id) {
				this.selected_complaint_id = id;
				const service = this.services.find((s) => s.id == id);
				this.completedModalService = service || null;
				this.remarks = "";
				this.initCompletedPaymentFromListService();
				if (service) {
					this.cost =
						service.total_amount != null && service.total_amount !== "" ? String(service.total_amount) : "";
					if (service.payment_status != null && service.payment_status !== "") {
						this.payment_status = String(service.payment_status);
					}
					if (service.payment_type != null && service.payment_type !== "") {
						this.payment_type = String(service.payment_type);
					}
					this.online_amount =
						service.cash_online != null && service.cash_online !== "" ? String(service.cash_online) : "";
					this.cash_amount =
						service.cash_in_hand != null && service.cash_in_hand !== "" ? String(service.cash_in_hand) : "";
					this.payment_id = service.payment_id != null && service.payment_id !== "" ? String(service.payment_id) : "";
					if (service.remarks) this.remarks = String(service.remarks);
				}
				this.isSubmittingCompleted = false;
				this.showCompletedModal();
			},

			closeCompletedModal() {
				this.hideCompletedModal();
				this.clearCompletedForm();
			},

			clearCompletedForm() {
				this.cost = "";
				this.payment_status = "";
				this.payment_type = "";
				this.payment_date = "";
				this.online_amount = "";
				this.cash_amount = "";
				this.payment_id = "";
				this.remarks = "";
				this.payment_by = "";
				this.payment_user_id = "";
				this.bank_account_id = "";
				this.amount_from_credit = "";
				this.deduct_from_credit = false;
				this.paymentDealerSearch = "";
				this.selectedPaymentDealer = null;
				this.paymentCustomerSearch = "";
				this.selectedPaymentCustomer = null;
				this.userCredit = null;
				this.userCreditError = "";
				this.prevShowUserCredit = false;
				this.selected_complaint_id = null;
				this.completedModalService = null;
				this.isSubmittingCompleted = false;
			},

			todayIsoDate() {
				const d = new Date();
				const y = d.getFullYear();
				const m = String(d.getMonth() + 1).padStart(2, "0");
				const day = String(d.getDate()).padStart(2, "0");
				return `${y}-${m}-${day}`;
			},

			submitCompleted() {
				if (this.isSubmittingCompleted) return;

				if (!this.payment_status) {
					this.$swal("Error", "Please select payment status", "error");
					return;
				}

				if (this.payment_status !== "4") {
					if (this.cost === "" || this.cost === null || this.cost === undefined) {
						this.$swal("Error", "Please enter total amount", "error");
						return;
					}
					if (!String(this.remarks || "").trim()) {
						this.$swal("Error", "Please enter remarks", "error");
						return;
					}
					if (!this.payment_by) {
						this.$swal("Error", "Please select payment by (dealer or customer)", "error");
						return;
					}
					if (!this.payment_user_id) {
						this.$swal("Error", "Please select who paid (dealer or customer)", "error");
						return;
					}
				}

				if (this.payment_status !== "4" && this.payment_status === "1") {
					if (!this.payment_type) {
						this.$swal("Error", "Please select payment type", "error");
						return;
					}
					if (this.payment_type !== "4" && !this.payment_date) {
						this.$swal("Error", "Please select payment date", "error");
						return;
					}
					if (this.payment_type === "2") {
						if (!this.online_amount || parseFloat(this.online_amount) <= 0) {
							this.$swal("Error", "Please enter online amount", "error");
							return;
						}
						if (!this.bank_account_id) {
							this.$swal("Error", "Please select bank", "error");
							return;
						}
						if (!String(this.payment_id || "").trim()) {
							this.$swal("Error", "Please enter payment ID", "error");
							return;
						}
					} else if (this.payment_type === "1") {
						if (!this.cash_amount || parseFloat(this.cash_amount) <= 0) {
							this.$swal("Error", "Please enter cash amount", "error");
							return;
						}
					} else if (this.payment_type === "3") {
						if (!this.online_amount || parseFloat(this.online_amount) <= 0) {
							this.$swal("Error", "Please enter online amount", "error");
							return;
						}
						if (!this.cash_amount || parseFloat(this.cash_amount) <= 0) {
							this.$swal("Error", "Please enter cash amount", "error");
							return;
						}
						if (!this.bank_account_id) {
							this.$swal("Error", "Please select bank", "error");
							return;
						}
						if (!String(this.payment_id || "").trim()) {
							this.$swal("Error", "Please enter payment ID", "error");
							return;
						}
					} else if (this.payment_type === "4") {
						const ca = parseFloat(this.amount_from_credit);
						if (!this.amount_from_credit || isNaN(ca) || ca <= 0) {
							this.$swal("Error", "Please enter amount from credit", "error");
							return;
						}
					}
				}

				if (this.showCompletedPaymentCredit) {
					const ca = parseFloat(this.amount_from_credit);
					if (!this.amount_from_credit || isNaN(ca) || ca <= 0) {
						this.$swal("Error", "Please enter amount from credit", "error");
						return;
					}
					if (this.userCredit && this.userCredit.credit_available_amount != null) {
						const avail = parseFloat(this.userCredit.credit_available_amount);
						if (!isNaN(avail) && ca > avail) {
							this.$swal("Error", "Amount from credit cannot exceed available credit", "error");
							return;
						}
					}
					const cap = parseFloat(this.cost) || 0;
					if (!isNaN(cap) && ca > cap) {
						this.$swal("Error", "Amount from credit cannot exceed total amount", "error");
						return;
					}
				}

				this.isSubmittingCompleted = true;
				this.getToken();

				const payload = {
					service_id: this.selected_complaint_id,
					total_amount: this.payment_status === "4" ? 0 : this.cost,
					payment_status: this.payment_status,
					remarks: this.remarks || "",
				};

				if (this.payment_status !== "4") {
					payload.payment_user_type = this.payment_by;
					payload.payment_user_id = this.payment_user_id;
					payload.deduct_from_credit =
						this.payment_status === "5"
							? 1
							: this.payment_status === "2"
								? this.deduct_from_credit
									? 1
									: 2
								: 2;
					payload.amount_from_credit = this.showCompletedPaymentCredit
						? parseFloat(this.amount_from_credit) || 0
						: 0;
					payload.bank_account_id = "";
					if (this.payment_status === "1") {
						payload.payment_type = this.payment_type;
						if (this.payment_type && this.payment_type !== "4") {
							payload.payment_date = this.payment_date;
						}
						if (this.payment_type === "2" || this.payment_type === "3") {
							payload.bank_account_id = this.bank_account_id;
							payload.cash_online = this.online_amount;
							payload.payment_id = this.payment_id;
						}
						if (this.payment_type === "1" || this.payment_type === "3") {
							payload.cash_in_hand = this.cash_amount;
						}
					}
				}

				this.$axios
					.post("/staffs/completeWorkStatus", payload, {
						headers: { Authorization: "Bearer " + this.token },
					})
					.then((res) => {
						this.isSubmittingCompleted = false;
						this.$swal("Success", res.data.message || "Work completed successfully", "success");
						this.closeCompletedModal();
						this.fetchServices();
					})
					.catch((err) => {
						this.isSubmittingCompleted = false;
						this.$swal("Error", err.response?.data?.message || "Failed to complete work", "error");
					});
			},

			
			// Filter complaints based on search term and status
			filterServices() {
				let filtered = [...this.all_complaints];

				// Filter by search term
				if (this.search_term.trim()) {
					const searchTerm = this.search_term.toLowerCase().trim();
					filtered = filtered.filter(complaint => 
						complaint.imei.toLowerCase().includes(searchTerm) ||
						complaint.vehicle_no.toLowerCase().includes(searchTerm) ||
						complaint.contact.toLowerCase().includes(searchTerm) ||
						complaint.complaint_type.toLowerCase().includes(searchTerm)
					);
				}

				// Filter by status
				if (this.status_filter) {
					filtered = filtered.filter(complaint => complaint.status == this.status_filter);
				}

				this.complaints = filtered;
			},

			// Get status badge class
			getStatusClass(status) {
				const statusClasses = {
					1: "bg-info",
					2: "bg-primary", 
					3: "bg-success", // Completed
					4: "bg-warning", // Manufacturer
					5: "bg-warning", // Assigned to Speedtech
					6: "bg-secondary" // Assigned to Dealer
				};
				return statusClasses[status] || "bg-secondary";
			},

			// Get status text
			getStatusText(status) {
				const statusTexts = {
					1: "Pending",
					2: "Ongoing",
					3: "Completed", 
					4: "Manufacturer",
					5: "Assigned to Speedtech",
					6: "Assigned to Dealer"
				};
				return statusTexts[status] || "Unknown";
			},

			// Handle form submission for updating complaint status
			submitStatusUpdate() {
				if (!this.selected_complaint_id) {
					this.$swal('Error', 'No complaint selected', 'error');
					return;
				}

				// Validate required fields
				if (!this.complaint_status) {
					this.$swal('Error', 'Please select a status', 'error');
					return;
				}

				if (this.material_change === '1' && (!this.product_id || !this.quantity)) {
					this.$swal('Error', 'Please fill in material details', 'error');
					return;
				}

				if (this.complaint_status === '1' && !this.cost) {
					this.$swal('Error', 'Please enter the cost', 'error');
					return;
				}

				// Validate payment fields when status is completed
				if (this.complaint_status === '1') {
					if (!this.payment_status) {
						this.$swal('Error', 'Please select payment status', 'error');
						return;
					}

					if (this.payment_status === 'received') {
						if (!this.payment_type) {
							this.$swal('Error', 'Please select payment type', 'error');
							return;
						}

						if (this.payment_type === '1') { // Online
							if (!this.online_amount || !this.payment_id) {
								this.$swal('Error', 'Please enter online amount and payment ID', 'error');
								return;
							}
							
							// Validate that online amount equals total amount
							const totalAmount = parseFloat(this.cost) || 0;
							const onlineAmount = parseFloat(this.online_amount) || 0;
							
							if (Math.abs(totalAmount - onlineAmount) > 0.01) {
								this.$swal('Error', 'Online amount must equal the total amount', 'error');
								return;
							}
						} else if (this.payment_type === '2') { // Cash
							if (!this.cash_amount) {
								this.$swal('Error', 'Please enter cash amount', 'error');
								return;
							}
							
							// Validate that cash amount equals total amount
							const totalAmount = parseFloat(this.cost) || 0;
							const cashAmount = parseFloat(this.cash_amount) || 0;
							
							if (Math.abs(totalAmount - cashAmount) > 0.01) {
								this.$swal('Error', 'Cash amount must equal the total amount', 'error');
								return;
							}
						} else if (this.payment_type === '3') { // Both
							if (!this.online_amount || !this.cash_amount || !this.payment_id) {
								this.$swal('Error', 'Please enter both online and cash amounts, and payment ID', 'error');
								return;
							}
							
							// Validate that total amount equals sum of online and cash amounts
							const totalAmount = parseFloat(this.cost) || 0;
							const onlineAmount = parseFloat(this.online_amount) || 0;
							const cashAmount = parseFloat(this.cash_amount) || 0;
							
							if (Math.abs(totalAmount - (onlineAmount + cashAmount)) > 0.01) {
								this.$swal('Error', 'Total amount must equal the sum of online and cash amounts', 'error');
								return;
							}
						}
					}
				}

				// Simulate API call
				this.loading = true;
				setTimeout(() => {
					// Update the complaint status in the local data
					const complaintIndex = this.all_complaints.findIndex(c => c.id === this.selected_complaint_id);
					if (complaintIndex !== -1) {
						this.all_complaints[complaintIndex].status = parseInt(this.complaint_status);
						this.all_complaints[complaintIndex].status_text = this.getStatusText(parseInt(this.complaint_status));
						this.all_complaints[complaintIndex].status_class = this.getStatusClass(parseInt(this.complaint_status));
						
						// Add payment information if status is completed
						if (this.complaint_status === '1') {
							this.all_complaints[complaintIndex].payment_status = this.payment_status;
							this.all_complaints[complaintIndex].payment_type = this.payment_type;
							this.all_complaints[complaintIndex].total_amount = this.cost;
							
							if (this.payment_status === 'received') {
								if (this.payment_type === '1') { // Online
									this.all_complaints[complaintIndex].online_amount = this.online_amount;
									this.all_complaints[complaintIndex].payment_id = this.payment_id;
								} else if (this.payment_type === '2') { // Cash
									this.all_complaints[complaintIndex].cash_amount = this.cash_amount;
								} else if (this.payment_type === '3') { // Both
									this.all_complaints[complaintIndex].online_amount = this.online_amount;
									this.all_complaints[complaintIndex].cash_amount = this.cash_amount;
									this.all_complaints[complaintIndex].payment_id = this.payment_id;
								}
							}
						}
						
						// Refresh the filtered list
						this.filterServices();
					}

					this.loading = false;
					this.closeModal();
					
					// Show success message with payment details
					let successMessage = 'Service status updated successfully';
					if (this.complaint_status === '1' && this.payment_status === 'received') {
						const paymentTypeText = this.payment_type === '1' ? 'Online' : 
											  this.payment_type === '2' ? 'Cash' : 
											  this.payment_type === '3' ? 'Both' : '';
						successMessage += ` with ${paymentTypeText} payment`;
					}
					
					this.$swal('Success', successMessage, 'success');
				}, 1000);
			},
			
		},
	};
</script>